export function mediaSrc(src) {
  if (!src) return "";
  const s = String(src);
  if (s.startsWith("data:") || s.startsWith("blob:") || /^https?:\/\//i.test(s)) return s;
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return `${base}/${s.replace(/^\//, "")}`;
}

export function isVideo(item) {
  if (!item) return false;
  if (item.mediaType === "video") return true;
  const s = String(item.img || item.picha || "");
  if (s.startsWith("data:video")) return true;
  return /\.(mp4|webm|mov|m4v)(\?|$)/i.test(s);
}

export const API = {
  list: `${process.env.PUBLIC_URL || ""}/api/list.php`.replace(/^\/\//, "/"),
  upload: `${process.env.PUBLIC_URL || ""}/api/upload.php`.replace(/^\/\//, "/"),
  remove: `${process.env.PUBLIC_URL || ""}/api/delete.php`.replace(/^\/\//, "/"),
};
